import { Controller } from "stimulus"

export default class extends Controller {

	static targets = ["sidebar", "rightPane", "form", "switcher", "sidebarActiveButtonsOnlyToggle"];

	connect() {

		this.selectedRole = null;
		this.roles = JSON.parse(this.element.dataset.roles);
		this.selectedUser = null;
		
	}


	toggleShowOnlyActiveSidebarButtons() {
		console.log("ok")
		document.querySelectorAll('.sidebar-item:not(.sidebar-header)[data-selected="false"]').forEach((el) => {
			 el.setAttribute('style', el.style.display == "none" ? 'display:flex !important' : 'display:none !important')
		})
	}

	showAllSidebarButtons() {
		document.querySelectorAll('.sidebar-item:not(.sidebar-header)').forEach((el) => {
			el.setAttribute('style', 'display:flex !important')
		})
	}

	registerSwitchUserBtnEventListeners() {
		document.querySelectorAll('.switch-user-btn').forEach((btn) => {
			btn.addEventListener("click", (e) => {
				this.deselectAllSwitchUserButtons()
				this.deselectAllSwitchRoleButtons()
				this.deselectAllActiveSidebarButtons();
				this.selectedRole = null;
				this.showAllSidebarButtons();
				let target = e.target;
				target.classList.toggle("bg-yellow-100");
				target.classList.toggle("text-white")
				target.classList.toggle("text-black");
				var arrow = target.querySelector(".selected-user-arrow")
				this.sidebarActiveButtonsOnlyToggleTarget.classList.remove("hidden")
				target.classList.contains("bg-yellow-100") ? arrow.classList.remove("hidden") : arrow.classList.add("hidden")

				target.dataset.selected = target.classList.contains("bg-yellow-100")
				this.toggleActiveButtonsBySelectedUser(target.dataset.user);
				this.selectedUser = target.dataset.user;
				
			})
		});
	}


	toggleActiveButtonsBySelectedUser(user) {
		var accessibleActions = JSON.parse(document.getElementById(`accessible_actions_for_user_${user}`).value);
		accessibleActions.forEach((action) => {
			document.querySelectorAll(`.sidebar-item[data-action="${action}"]`).forEach((sidebarItem) => {
				this.toggleActiveButton(sidebarItem);
			});
		});
	}



	deselectAllSwitchUserButtons() {
		document.querySelectorAll('.switch-user-btn').forEach((btn) => {
				btn.dataset.selected = false;  
				btn.classList.remove('bg-yellow-100');
				btn.classList.remove('text-black');
				btn.classList.add('text-white')
				btn.querySelector(".selected-user-arrow").classList.add("hidden")
			})
	}

	deselectAllSwitchRoleButtons() {
		document.querySelectorAll('.switch-role-btn').forEach((btn) => {
				btn.dataset.selected = false;  
				btn.classList.remove('bg-green-100');
				btn.querySelector(".selected-role-arrow").classList.add("hidden")
			})
	}



	registerSwitchRoleBtnEventListeners() {
		document.querySelectorAll('.switch-role-btn').forEach((btn) => {
			btn.addEventListener("click", (e) => {
				this.deselectAllSwitchRoleButtons()
				this.deselectAllSwitchUserButtons()
				this.deselectAllActiveSidebarButtons();
				this.selectedUser = null;
				this.showAllSidebarButtons();
				let target = e.target;
				target.classList.toggle("bg-green-100");
				var arrow = target.querySelector(".selected-role-arrow")
				this.sidebarActiveButtonsOnlyToggleTarget.classList.remove("hidden")
				target.classList.contains("bg-green-100") ? arrow.classList.remove("hidden") : arrow.classList.add("hidden")

				target.dataset.selected = target.classList.contains("bg-green-100")
				this.toggleActiveButtonsBySelectedRole(btn.dataset.role);
				this.selectedRole = target.dataset.role;
				
			})
		});
	}

	enterEditMode() {
		this.switcherTarget.classList.toggle("hidden")

		this.registerSwitchRoleBtnEventListeners()
		this.registerSwitchUserBtnEventListeners()
		var sidebarEntries = this.sidebarTarget.querySelectorAll('.sidebar-item');
		this.rightPaneTarget.classList.add("opacity-30");
		sidebarEntries.forEach(entry => {
			entry.classList.remove('hover:bg-gray-200')
			entry.classList.add("opacity-20", "hover:bg-green-200");
			entry.dataset.selected = false;
			this.handleClickOnSidebarButton(entry);
		});
	}

	exitEditMode() {
		this.switcherTarget.classList.add("hidden")
		this.selectedRole = null
		this.selectedUser = null

		var sidebarEntries = this.sidebarTarget.querySelectorAll('.sidebar-item');
		this.rightPaneTarget.classList.remove("opacity-30");
		sidebarEntries.forEach(entry => {
			entry.classList.add('hover:bg-gray-200')
			entry.classList.remove("opacity-20", "hover:bg-green-200");
			entry.dataset.selected = false;
		});

	}



	deselectAllActiveSidebarButtons() {
		document.querySelectorAll('.sidebar-item[data-selected="true"]').forEach((btn) => {
			this.toggleActiveButton(btn)
		})
	}

	handleClickOnSidebarButton(element) {
		
		element.addEventListener('click', (e) => {
			if (this.selectedRole == null && this.selectedUser == null) return
			
			e.preventDefault()

			if (document.querySelectorAll('.switch-role-btn[data-selected="true"]').length == 0 && document.querySelectorAll('.switch-user-btn[data-selected="true"]').length == 0) return;

			var target = e.target;
			['opacity-20', 'hover:bg-gray-200', 'bg-green-300', 'hover:bg-green-200', 'active:bg-green-200', 'selected:bg-green-200'].forEach((className) => {
				target.classList.toggle(className);
			});
			target.dataset.selected = target.classList.contains('bg-green-300')
		});

	}



	save(e) {
		e.preventDefault();
		if (!!this.selectedRole || !!this.selectedUser) {

			if (this.selectedRole) {
				console.log("saving permissions for role...", this.selectedRole);
			} else if (this.selectedUser) {
				console.log("savign permissions for user...", this.selectedUser);
			}

			var currentRoleHiddenField = document.getElementById(`accessible_actions_for_role_${this.selectedRole}`);
			var currentUserHiddenField = document.getElementById(`accessible_actions_for_user_${this.selectedUser}`);

			var accessibleActions = []
			document.querySelectorAll('.sidebar-item[data-selected="true"]').forEach((activeBtn) => {
				accessibleActions.push(activeBtn.dataset.action);
			})

			if (!!this.selectedRole) {
				currentRoleHiddenField.value = JSON.stringify([...new Set(accessibleActions)])
			} else if (!!this.selectedUser) {
				currentUserHiddenField.value = JSON.stringify([...new Set(accessibleActions)])
			}
			this.formTarget.requestSubmit()

		}
	}


	toggleActiveButtonsBySelectedRole(role) {
		var accessibleActions = JSON.parse(document.getElementById(`accessible_actions_for_role_${role}`).value);
		accessibleActions.forEach((action) => {
			document.querySelectorAll(`.sidebar-item[data-action="${action}"]`).forEach((sidebarItem) => {
				this.toggleActiveButton(sidebarItem);
			});
		});
	}

	toggleActiveButton(target) {
		['opacity-20', 'hover:bg-gray-200', 'bg-green-300', 'hover:bg-green-200', 'active:bg-green-200', 'selected:bg-green-200'].forEach((className) => {
				target.classList.toggle(className);
		});
		target.dataset.selected = target.classList.contains("bg-green-300")
	}


}